import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import DataTable from '../../../components/table/DataTable'
import { auditSubtitleSx } from './rbacAuditHistoryConstants'

export default function RbacAuditHistoryTabShell({
  subtitle,
  subtitleSx = auditSubtitleSx,
  ariaLabel,
  columns,
  rows,
  loading = false,
  renderSkeletonRows = null,
  emptyState,
  pagination,
  onPageChange,
  onRowsPerPageChange,
  paginationAriaLabel
}) {
  return (
    <div className="container-fluid px-0">
      <Box sx={{ mt: 3, mb: 2.5, ml: '5px' }}>
        <Typography sx={subtitleSx}>
          {subtitle}
        </Typography>
      </Box>

      <DataTable
        ariaLabel={ariaLabel}
        columns={columns}
        rows={rows}
        rowKey="id"
        loading={loading}
        renderSkeletonRows={renderSkeletonRows}
        emptyState={emptyState}
        pagination={pagination?.total_count > 0 ? pagination : null}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        paginationAriaLabel={paginationAriaLabel}
        paginationSx={{ mb: 0, px: 2.5 }}
        variableRowHeight
      />
    </div>
  )
}
